// extracted by mini-css-extract-plugin
export const root = "exhibition-preview-module--root--h2ka1";
export const thumb = "exhibition-preview-module--thumb---oVtx";
export const text = "exhibition-preview-module--text--KjrF9";
export const title = "exhibition-preview-module--title--1zrop";